import { DeleteOutlined, LockOutlined, SaveOutlined, PlusCircleOutlined } from '@ant-design/icons';
import Confirmation from '@app/common/Confirmation';
import { Can } from '@app/modules/Auth';
import { Col, Card, Form, Button, Row, Select, Input, Checkbox, Statistic } from 'antd';
import React, { useMemo } from 'react';

const LevelsForm = ({
  selBuildLevelsCount,
  handleLevelDelete,
  selLevel,
  handleLevelEdit,
  handleLevelAdd,
  handleLevelChange,
  listLevels,
  selLevelValue,
  handleLevelNameChange,
  useMainProfileLevel,
  handleCheck3,
  levelProf,
  levelProfChanged,
  profileItems,
  selLevelRoomsCount
}) => {
  const levelItems = useMemo(() => {
    return listLevels.map(level => (
      <Select.Option key={level.id} value={level.id} id={level.id}>
        {level.name}
      </Select.Option>
    ));
  }, [listLevels]);

  return (
    <Col span={12}>
      <form>
        <Card
          className="card-stats"
          title={`Levels list (${selBuildLevelsCount} levels)`}
          actions={[
            <Form.Item className="actions">
              <Can
                action="delete:levels"
                yes={close => (
                  <Confirmation
                    onOk={async close => {
                      await handleLevelDelete();
                      close();
                    }}
                    content={`Delete this level ? `}
                    title={`Confirm delete operation`}
                  >
                    {open => (
                      <Button
                        type="primary"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => open()}
                        disabled={!selLevel}
                      >
                        Delete
                      </Button>
                    )}
                  </Confirmation>
                )}
                no={() => (
                  <Button type="primary" danger disabled icon={<LockOutlined />}>
                    Delete
                  </Button>
                )}
              />
              <Can
                action="put:levels"
                yes={() => (
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={handleLevelEdit}
                    className="btn btn-primary"
                    disabled={!selLevel}
                  >
                    Save
                  </Button>
                )}
                no={() => (
                  <Button type="primary" disabled icon={<LockOutlined />}>
                    Save
                  </Button>
                )}
              />
              <Can
                action="post:levels"
                yes={() => (
                  <Button icon={<PlusCircleOutlined />} onClick={handleLevelAdd}>
                    Add
                  </Button>
                )}
                no={() => (
                  <Button className="btn btn-success" disabled icon={<LockOutlined />}>
                    Add
                  </Button>
                )}
              />
            </Form.Item>
          ]}
        >
          <Row>
            <Col lg={24} md={24}>
              <Form.Item className="vertical-select" rules={[{ required: true }]} label="Select Level:">
                <Select id="levelsList" size="middle" value={selLevel || ''} onChange={handleLevelChange}>
                  {levelItems}
                </Select>
              </Form.Item>
              <Form.Item className="input-field" label="Level name:">
                <Input type="text" value={selLevelValue} onChange={handleLevelNameChange} id="levelName" />
              </Form.Item>
              <Form.Item className="input-checkbox" label="Use main profile for all rooms">
                <Checkbox id="check3" checked={useMainProfileLevel} onChange={handleCheck3} />
              </Form.Item>
              {useMainProfileLevel && (
                <Form.Item className="select-profile" label="Energy profile:">
                  <Select id="levelProfile" size="middle" value={levelProf} onChange={levelProfChanged}>
                    {profileItems}
                  </Select>
                </Form.Item>
              )}
              <Row gutter={16} className="pt-20">
                <Col span={12}>
                  <Statistic title="Rooms count:" value={selLevelRoomsCount} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </form>
    </Col>
  );
};
export default LevelsForm;
